import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import { hasValidBlackoutRange } from './appliedBlackoutUtils';
import type { SalesforceBlackoutDate } from './types';

interface Props {
  blackoutDate: SalesforceBlackoutDate;
  hasMatchingAssignments: boolean;
}

export default function BlackoutMatchStatusChip({ blackoutDate, hasMatchingAssignments }: Props) {
  if (hasMatchingAssignments) {
    return null;
  }

  if (hasValidBlackoutRange(blackoutDate.from__c, blackoutDate.to__c)) {
    return <Chip color="default" label="Not applied" size="small" sx={{ flexShrink: 0 }} variant="outlined" />;
  }

  return (
    <Tooltip title="No From/To in Salesforce — likely applies across all periods per CM convention. Check the unmatched list below for a likely match.">
      <Chip color="info" label="No date range in Salesforce" size="small" sx={{ flexShrink: 0 }} variant="outlined" />
    </Tooltip>
  );
}
